import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { ReactComponent as ChevronRight } from "../../../../assets/img/icon/chevron_right_black_24dp.svg";
import { ReactComponent as People } from "../../../../assets/img/icon/people_black_24dp.svg";
import { COLOR, GRAPH_COLOR, VARIABLE } from "../../../../config/constant";
import {
  formatter,
  getDateFormat,
  getDateFormat2,
} from "../../../../helpers/helper";
import { Patient } from "../../../../models/Patient";
import { getPatientDetail } from "../../../../services/httpService/patientRequest";
import { getRecordStat } from "../../../../services/httpService/recordRequest";
import { GlobalContext } from "../../../contexts/globalContext";
import Button from "../../../ui/atoms/Button/Button";
import ChartLine from "../../../ui/atoms/ChartLine/ChartLine";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";
import PatientInfo from "../../../ui/atoms/PatientInfo/PatientInfo";

const dateNow = getDateFormat(new Date());
const PatientRecordStatistic = () => {
  const isMounted = useRef(true);
  const params = useParams();
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [state, setState] = useState({
    startDate: "",
    endDate: "",
    oStartDate: "",
    oEndDate: "",
    message:
      "Silakan isi periode waktu untuk membuat rekapitulasi statistik rekam medis.",
    isTable: true,
  });
  const [patient, setPatient] = useState();
  const [records, setRecords] = useState("");

  const handleGetData = async () => {
    try {
      let { result } = await getPatientDetail(
        `${params.id}?doctor=${sharedState.user._id}`
      );
      if (result === null) throw new Error("Invalid request");
      if (isMounted.current)
        setPatient(
          new Patient(result.user._id, result.user.name, result.user.profile)
        );
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleGetStatisticRecord = async () => {
    try {
      if (state.endDate === "" || state.startDate === "")
        throw new Error("Interval waktu harus diisi");
      if (new Date(state.startDate) > new Date(state.endDate))
        throw new Error("Interval waktu salah");
      if (!isMounted.current) return null;
      dispatch("isLoading", true);
      let { result } = await getRecordStat(
        `startDate=${state.startDate}&endDate=${state.endDate}&patient=${params.id}`
      );

      if (result.length === 0) throw new Error("Data tidak ditemukan");
      result.map((res) => {
        res["createdAt"] = getDateFormat2(res["createdAt"], true);
      });

      if (!isMounted.current) return null;
      setRecords(result);
      setState((prevState) => ({
        ...prevState,
        message: "",
        oStartDate: getDateFormat2(state.startDate),
        oEndDate: getDateFormat2(state.endDate),
      }));

      dispatch("isLoading", false);
    } catch (error) {
      if (!isMounted.current) return null;
      dispatch("alert", {
        show: true,
        type: "warning",
        message: error.message,
      });
      dispatch("isLoading", false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    handleGetData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Pasien"
          description="Dapatkan informasi pasien beserta dengan riwayat medisnya."
          icon={
            <People className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />
        <PatientInfo patient={patient} className="mt-6" />

        {/* SUBMENU */}
        <div className="mt-10 flex flex-col md:flex-row justify-start md:justify-between items-center">
          {/* LEFT SUBMENU */}
          <div className="w-full xl:w-2/3 flex flex-wrap">
            <div className="w-full flex space-x-2 items-center mr-2 mt-2">
              <div className="text-primary font-medium flex-shrink-0 hidden md:block">
                Periode :
              </div>
              <input
                className="w-1/3 md:w-40 border-b border-primary text-primary px-1 focus:outline-none"
                type="date"
                name="startDate"
                placeholder="yyyy-mm-dd"
                value={state.startDate}
                onChange={handleChange}
                max={dateNow}
              />
              <span>-</span>
              <input
                className="w-1/3 md:w-40 border-b border-primary text-primary px-1 focus:outline-none"
                type="date"
                name="endDate"
                placeholder="yyyy-mm-dd"
                value={state.endDate}
                onChange={handleChange}
                min={state.startDate}
                max={dateNow}
              />
              <Button
                className="w-1/4 md:w-24 flex-shrink-0 bg-primary rounded px-2 py-1 text-sm text-white"
                handleClick={handleGetStatisticRecord}
              >
                Buat Rekap
              </Button>
            </div>
          </div>
          {/* RIGHT SUBMENU */}
          <div className="w-full xl:w-1/3 flex space-x-3 justify-end mt-3 lg:mt-0">
            <Link to={`/patient/${params.id}`}>
              <div className="text-primary cursor-pointer flex items-center ">
                <div>
                  <ChevronRight fill={COLOR.PRIMARY} className="w-6 h-6" />
                </div>
                <div className="ml-1 border-b border-transparent hover:border-primary">
                  Kembali
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="mt-6 pb-24">
          <div className="w-full">
            <div className="border border-primary shadow-lg rounded-lg px-2 md:px-4 pt-3 pb-5">
              {state.message ? (
                <div className="mt-1">{state.message}</div>
              ) : (
                <>
                  <div>
                    <h4 className="font-semibold">
                      Rekapitulasi Pengukuran Mode Basic
                    </h4>
                    <div className="mt-3 font-semibold">
                      &bull; Informasi Umum
                    </div>
                    <table className="mt-1">
                      <tbody>
                        <tr>
                          <td className="w-36">Interval Waktu</td>
                          <td className="px-3">:</td>
                          <td>
                            {state.oStartDate} - {state.oEndDate}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-36">Banyak Pengukuran</td>
                          <td className="px-3">:</td>
                          <td>{records.length} Kali</td>
                        </tr>
                      </tbody>
                    </table>

                    <div>
                      <div className="mt-3 flex justify-between items-center">
                        <div className="font-semibold">
                          &bull; Data Statistik
                        </div>
                        <div className="w-44 flex justify-between rounded overflow-hidden">
                          <div
                            className={
                              "cursor-pointer w-1/2 px-2 bg-gray-500 text-white text-center tracking-wider " +
                              (state.isTable ? "" : "bg-opacity-50")
                            }
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                isTable: true,
                              }))
                            }
                          >
                            Tabel
                          </div>
                          <div
                            className={
                              "cursor-pointer w-1/2 px-2 bg-gray-500 text-white text-center tracking-wider " +
                              (state.isTable ? "bg-opacity-50" : "")
                            }
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                isTable: false,
                              }))
                            }
                          >
                            Grafik
                          </div>
                        </div>
                      </div>

                      <div className="mt-1">
                        {VARIABLE.basic.map((variable) => (
                          <div className="mb-5" key={"table-" + variable.key}>
                            <div className="bg-primary bg-opacity-20 py-1.5 px-1">
                              <div>{variable.label}</div>
                            </div>
                            {state.isTable ? (
                              <div className="text-sm overflow-x-auto">
                                <table className="w-full">
                                  <thead>
                                    <tr className="bg-secondary text-white">
                                      <th className="px-1 py-2 w-64">
                                        Pengukuran
                                      </th>
                                      <th className="px-1 py-2 w-20">n</th>
                                      <th className="px-1 py-2 w-20">Min</th>
                                      <th className="px-1 py-2 w-20">Max</th>
                                      <th className="px-1 py-2 w-20">Mean</th>
                                      <th className="px-1 py-2 w-20">Stdv</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {records.map((record, idx) => (
                                      <tr
                                        key={record._id + variable.key}
                                        className={
                                          "bg-secondary " +
                                          (idx % 2 !== 0
                                            ? "bg-opacity-20"
                                            : "bg-opacity-0")
                                        }
                                      >
                                        <td className="px-1 py-1.5">
                                          <div className="flex flex-col md:flex-row space-x-0 md:space-x-3">
                                            <div>
                                              {`Pengukuran ke-${record.testNumber}`}
                                            </div>
                                            <div>({record.createdAt})</div>
                                          </div>
                                        </td>
                                        <td className="px-1 py-1.5 text-center">
                                          {record[variable.key]
                                            ? formatter.format(
                                                record[variable.key]["n"]
                                              )
                                            : "-"}
                                        </td>
                                        <td className="px-1 py-1.5 text-center">
                                          {record[variable.key] &&
                                          record[variable.key]["min"]
                                            ? formatter.format(
                                                record[variable.key]["min"]
                                              )
                                            : "-"}
                                        </td>
                                        <td className="px-1 py-1.5 text-center">
                                          {record[variable.key] &&
                                          record[variable.key]["max"]
                                            ? formatter.format(
                                                record[variable.key]["max"]
                                              )
                                            : "-"}
                                        </td>
                                        <td className="px-1 py-1.5 text-center">
                                          {record[variable.key] &&
                                          record[variable.key]["avg"]
                                            ? formatter.format(
                                                record[variable.key]["avg"]
                                              )
                                            : "-"}
                                        </td>
                                        <td className="px-1 py-1.5 text-center">
                                          {record[variable.key] &&
                                          record[variable.key]["stdv"]
                                            ? formatter.format(
                                                record[variable.key]["stdv"]
                                              )
                                            : "-"}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <div className="h-64 text-xs md:text-sm">
                                <ChartLine
                                  data={records}
                                  dataKeyY={[
                                    `${variable.key}.avg`,
                                    `${variable.key}.stdv`,
                                    `${variable.key}.min`,
                                    `${variable.key}.max`,
                                  ]}
                                  dataKeyX="createdAt"
                                  stroke={GRAPH_COLOR}
                                  dot={true}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientRecordStatistic;
